<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { useClassStore, useUserStore } from '../../stores';
import { UserRole } from '../../types/user';
import { utils } from '../../utils';
import Heading from '../General/Heading.vue';
import LeaderboardItem from './LeaderboardItem.vue';
import { ClassViewType } from '../../types/class';

const classStore = useClassStore()
const userStore = useUserStore()

const { t } = useI18n()
</script>

<template>
    <Heading>{{ t(TEXT.personal_ranking) }}</Heading>
    <div class="w-full overflow-auto pe-1">
        <LeaderboardItem v-if="!classStore.rankedStudents.length" />
        <template v-else>
            <LeaderboardItem v-for="student in classStore.rankedStudents" :key="student.id" :id="student.id"
                :type="ClassViewType.student" :rank="student.rank" :name="student.full_name"
                :info="userStore.userRole === UserRole.teacher ? `(${student.username})` : ''"
                :point="utils.calculateTotalPoint(student.bonus_point)" />
        </template>
    </div>
</template>